import styled from 'styled-components'

import { TypeStyle, timingSlower } from '@syconium/little-miss-figgy'

import { fadeIn } from '../../../../../../brunswick/styles/shared'

export const Wrapper = styled.div`
  width: 264px;
`

export const FilterActions = styled.div`
  background-color: white;
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  display: flex;
  justify-content: space-between;
  letter-spacing: 1px;
  padding-bottom: 20px;
  z-index: ${o => o.theme.zIndex.foregroundContent};
`

export const FilterHeadline = styled.div`
  ${TypeStyle.css.headlineExtraSmall}
  color: ${o => o.theme.color.deprecated.obsidian};
  line-height: 40px;
`

export const ClearFiltersButton = styled.button`
  animation: ${fadeIn} ${timingSlower} ease 0s 1 both;
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  font-size: 13px;
  outline: none;
  text-transform: uppercase;

  &:hover {
    color: ${o => o.theme.color.deprecated.obsidianLight};
  }
`
